import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useTranslation } from 'react-i18next';

function formatRelativeDraft(dateStr, t) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return null;
  const diffMs = Date.now() - date.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return t('explore.draftBadge.justNow', 'ahora');
  if (diffMin < 60) return t('explore.draftBadge.minutesAgo', 'hace {{count}} min', { count: diffMin });
  const diffHours = Math.floor(diffMin / 60);
  if (diffHours < 24) return t('explore.draftBadge.hoursAgo', 'hace {{count}} h', { count: diffHours });
  const diffDays = Math.floor(diffHours / 24);
  return t('explore.draftBadge.daysAgo', 'hace {{count}} d', { count: diffDays });
}

const AgentDraftBadge = ({ hasDraft, draftUpdatedAt }) => {
  const { t } = useTranslation();
  if (!hasDraft) return null;
  const relative = formatRelativeDraft(draftUpdatedAt, t);
  return (
    <Tooltip title={t('explore.draftBadge.tooltip', 'Tiene cambios sin publicar. Abre el agente para revisar y publicar.')}>
      <Chip
        size="small"
        icon={<EditNoteIcon sx={{ fontSize: 14 }} />}
        label={
          relative
            ? t('explore.draftBadge.labelWithTime', 'borrador · {{relative}}', { relative })
            : t('explore.draftBadge.label', 'borrador')
        }
        sx={{
          height: 20,
          bgcolor: (theme) => theme.palette.warning.main + '1A',
          color: 'warning.dark',
          '& .MuiChip-icon': { color: 'warning.main', ml: 0.5 },
          '& .MuiChip-label': { px: 0.75, fontSize: '0.7rem', fontWeight: 500 },
        }}
      />
    </Tooltip>
  );
};

export { formatRelativeDraft };
export default AgentDraftBadge;
